module.exports = __webpack_public_path__ + "static/media/web-development.e74ef63b.png";